import {Routes} from '@angular/router'
import {
  adminAuthGuard,
  LoginComponent
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {
  ADVICE_PATH,
  CUSTOMER_PATH,
  CUSTOMER_START,
  LOGIN_PATH,
  MODEL_PORTFOLIO_PATH,
  RTQ_PATH
} from './application/constants'

export const routes: Routes = [
  {
    path: `${ADVICE_PATH}/:customerId/:adviceId`,
    loadComponent: () => import('./advice/advice.component').then(m => m.AdviceComponent),
    canActivate: [adminAuthGuard]
  },
  {
    path: RTQ_PATH,
    loadComponent: () => import('./rtq/rtq.component').then(m => m.RtqComponent),
    canActivate: [adminAuthGuard]
  },
  {
    path: CUSTOMER_START,
    loadComponent: () => import('./customer/start/start.component').then(m => m.StartComponent),
    canActivate: [adminAuthGuard]
  },
  {
    path: CUSTOMER_PATH,
    loadComponent: () => import('./customer/customer.component').then(m => m.CustomerComponent),
    canActivate: [adminAuthGuard]
  },
  {
    path: MODEL_PORTFOLIO_PATH,
    loadComponent: () => import('./model-portfolio-overview/model-portfolio-overview.component').then(m => m.ModelPortfolioOverviewComponent),
    canActivate: [adminAuthGuard]
  },
  {
    path: LOGIN_PATH,
    component: LoginComponent
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LOGIN_PATH
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
]
